// @flow
import * as React from 'react';
import {Component, createContext} from 'react';
import AbacusContext, {type AbacusContextType} from './AbacusContext';

import type {State as AbacusState} from '../../reducers/abacus';

export const ExperimentContext = createContext(new AbacusContext());

type Props = {abacus: AbacusState, children?: React.Node};
type State = {abacusContext: AbacusContext};
export type ExperimentProviderContextValue = AbacusContextType;

class ExperimentProvider extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const {abacus} = this.props;
        this.state = {
            abacusContext: new AbacusContext(abacus)
        };
    }
    render() {
        return (
            <ExperimentContext.Provider value={this.state.abacusContext}>
                {this.props.children}
            </ExperimentContext.Provider>
        );
    }
}

export default ExperimentProvider;
